const METADATA_TIMEOUT_MS = 10000;

/**
 * Read a video's duration and ratio without playing it.
 *
 * @param {string} url  usually a blob URL of a picked file
 * @returns {Promise<{ duration: number, aspectRatio: number } | null>}
 *          null when the browser cannot read the file (codec, revoked URL, timeout)
 */
export function readVideoMetadata(url) {
    return new Promise((resolve) => {
        const video = document.createElement("video");
        let settled = false;

        function finish(result) {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            video.removeAttribute("src");
            video.load();
            resolve(result);
        }

        const timer = setTimeout(() => finish(null), METADATA_TIMEOUT_MS);

        video.preload = "metadata";
        video.muted = true;
        video.onloadedmetadata = () => {
            const { videoWidth, videoHeight, duration } = video;
            finish(
                videoWidth && videoHeight
                    ? { duration: isFinite(duration) ? duration : 0, aspectRatio: videoWidth / videoHeight }
                    : null
            );
        };
        video.onerror = () => finish(null);
        video.src = url;
    });
}
